export default __webpack_public_path__ + "static/media/image.818f95dd.png";